import React from "react";

export function CompetitorBlockNoData(competitor) {
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            <div></div>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-name'>{!competitor.cp_prev_wlt ? competitor?.cp_prev_pos : ''} </div>
            {/* <div className='score-name'>{competitor?.cp_prev_pos}  </div>*/}
        </div>
    )
}
